import React from "react";
import { useState, useEffect } from "react";
import { TitleComponent, CardComponent, TableComponent, ButtonGenerateComponent, ButtonGenerateExcelComponent, ButtonActionComponent, CellComponent, PortalComponent, ModalComponent, SelectComponent, SelectComponentMulti } from '../../../components/pages/index';
import { api, apiConfig } from "../../../util/api";
import HeaderMenu from '../../layout/headerMenu';
import "../reports.css";
import { useGetApiWs } from '../../../hooks/index';
import { getInfoUser } from '../../../util/auth';

const AmplitudeAttribute = (props) => {
    const urlCustomer = useGetApiWs('admin', 'entity', 'company-get');
    const urlCustonerInfo = useGetApiWs('admin', 'entity', 'customer-get');
    const urlSkuFeatureInfo = useGetApiWs('admin', 'entity', 'sku-feature-get');
    const urlFilter = useGetApiWs('admin', 'entity', 'generate-report');

    const [defcities, setDefCities] = useState([]);
    const [defattributes, setDefAttributes] = useState([]);
    const [defchannels, setDefChannels] = useState([]);


    const [defperiods, setDefPeriods] = useState([]);
    const [periodsIsDisabled, setPeriodsIsDisabled] = useState(false);

    const [cities, setCities] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [category, setCategory] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [channels, setChannels] = useState([]);
    const [periods, setPeriods] = useState([]);
    const [attributesType, setAttributesType] = useState([]);


    const [lbCategory, setLbCategory] = useState(null);
    const [lbCustomer, setLbCustomer] = useState(null);
    const [lbCities, setLbCities] = useState(null);
    const [lbAttributes, setLbAttributes] = useState(null);
    const [lbAttributesTypes, setLbAttributesTypes] = useState(null);
    const [lbChannels, setLbChannels] = useState(null);
    const [lbValores, setLbValores] = useState(null);
    const [lbTipoDetalle, setLbTipoDetalle] = useState(null);
    const [lbTipoReporte, setLbTipoReporte] = useState(null);
    const [lbPeriods, setLbPeriods] = useState(null);


    const [customerIsLoading, setCustomerIsLoading] = useState(true);
    const [categoryIsLoading, setCategoryIsLoading] = useState(true);
    const [citiesIsLoading, setCitiesIsLoading] = useState(false);
    const [attributesIsLoading, setAttributesIsLoading] = useState(false);
    const [channelsIsLoading, setChannelsIsLoading] = useState(false);

    const [channelsIsDisabled, setChannelsIsDisabled] = useState(false)

    const [tbHeadings, setTbDataHeadings] = useState([]);
    const [btnExports, setBtnExports] = useState(false);
    const [tbColumns, setTbColumns] = useState([]);
    const [tbData, setTbData] = useState([]);
    const [tbPending, setTbPending] = useState(false);
    const [Disabled, setDisabled] = useState();
    const data = JSON.parse(getInfoUser());

    const tipoDetalle = [{ 'value': 0, 'label': 'Amplitud', }, { 'value': 1, 'label': 'Detallado', }];
    const [valores, setValores] = useState([]);

    const wbname = 'AmplitudSKU-Marcas'

    const fetchCustomers = async () => {
        const customers = await api().post(urlCustomer, { company_type_code: 'CM-CUST' }, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.company_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setCustomers(options);
        setCustomerIsLoading(false);
        if (data.code == 'CM-CUST') {
            CustomerChange({ 'value': data.company_id, 'label': data.company_name })
            setDisabled(true);
        } else {
            setDisabled(false);
        }

    }
    const fetchCategory = async (customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['study_id'] = 8;
        ob['type_info'] = 'categories';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const cWorkOrders = await api().post(urlCustonerInfo, ob, apiConfig());
        if (cWorkOrders.status === 200 && cWorkOrders.data.status === 'success') {
            var options = cWorkOrders.data.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.category_id;
                rObj['label'] = obj.category_name;
                return rObj;
            })
            setCategory(options);
        }
        setCategoryIsLoading(false);
    }
    const fetchCities = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 8;
        ob['type_info'] = 'cities';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const customers = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.city_id;
            rObj['label'] = obj.name;
            return rObj;
        });
        setCities(options);
        setCitiesIsLoading(false);
    }

    const fetchAttributes = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 8;
        ob['type_info'] = 'attributes';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const customers = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.feature_type_id;
            rObj['label'] = obj.feature_type_name;
            return rObj;
        });
        options.push({ value: -1, label: 'NIVEL SKU' })
        setAttributes(options);
    }
    const fetchAttributesTypes = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 8;
        ob['type_info'] = 'attributes';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const customers = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.feature_type_id;
            rObj['label'] = obj.feature_type_name;
            return rObj;
        });
        setAttributesType(options)
    }

    const fetchChannels = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 8;
        ob['type_info'] = 'channels';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const channels = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = channels.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.channel_id;
            rObj['label'] = obj.name;
            return rObj;
        });
        setChannels(options);
        setChannelsIsLoading(false);
    }

    const fetchPeriods = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 8;
        ob['type_info'] = 'periods';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const periods = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = periods.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.period_id;
            rObj['label'] = obj.value;
            return rObj;
        });
        setPeriods(options);
    }

    const fetchValues = async (category_id, attributes) => {
        const ob = {};
        ob['category_id'] = category_id;
        ob['attribute'] = attributes;

        const val = await api().post(urlSkuFeatureInfo, ob, apiConfig());
        var options = val.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.value;
            rObj['label'] = obj.value;
            return rObj;
        });
        setValores(options);
    }

    const CustomerChange = async vals => {
        setLbCustomer(vals);
        setBtnExports(false);
        if (vals === null) {
            setCategory([]);
            setLbCategory(null);
            setAttributes([]);
            setLbAttributes(null);
            setCities([]);
            setLbCities(null);
            setChannels([]);
            setLbChannels(null);
            setPeriods([]);
            setLbPeriods(null);
        } else {
            setCategory([]);
            setLbCategory(null);
            fetchCategory(vals.value);
        }
    }

    const CategoryChange = async vals => {
        setLbCategory(vals);
        setBtnExports(false);
        if (vals === null) {
            setAttributes([]);
            setLbAttributes(null);
            setCities([]);
            setLbCities(null);
            setChannels([]);
            setLbChannels(null);
            setPeriods([]);
            setLbPeriods(null);
        } else {
            fetchAttributes(vals.value, lbCustomer.value);
            fetchAttributesTypes(vals.value, lbCustomer.value);
            fetchCities(vals.value, lbCustomer.value);
            fetchChannels(vals.value, lbCustomer.value);
            fetchPeriods(vals.value, lbCustomer.value);
        }
    }

    const CityChange = async vals => {
        setLbCities(vals);
        setBtnExports(false);

        const arrCities = vals.map((obj) => {
            return obj.label
        })

        if (arrCities.length === 1) {
            setChannelsIsDisabled(false);
        } else {
            setDefChannels(channels);
            setChannelsIsDisabled(false);
        }
        if (arrCities.length === 0) {
            setChannelsIsDisabled(false);
        }
    }

    const AttributeChange = async vals => {
        setLbAttributes(vals);
        setBtnExports(false);
        if (vals != null || vals.label != 'NIVEL SKU') {
            fetchValues(lbCategory.value, vals.value)
        }
    }
    const AttributeTypesChange = async vals => {
        setLbAttributesTypes(vals);
        setBtnExports(false);
    }

    const ValoresChange = async vals => {
        setLbValores(vals);
        setBtnExports(false);
    }

    const TipoDetalleChange = async vals => {
        setLbTipoDetalle(vals);
        setBtnExports(false);
    }

    const ChannelsChange = async vals => {
        setLbChannels(vals);
        setBtnExports(false);
    }

    const PeriodsChange = async vals => {
        setLbPeriods(vals);
        setBtnExports(false);
    }

    const Filter = () => {
        fetchFilters();
        showList();

    }

    const fetchFilters = async () => {
        if (lbTipoReporte.value == 0) {
            setTbPending(true);
            const ob = {};
            ob['type'] = 'chequeo_amplitud_atributo';
            ob['customer_id'] = lbCustomer.value;
            ob['category_id'] = lbCategory.label + '|' + lbCategory.value + '|';
            ob['value'] = lbValores.value;
            ob['type_detail'] = lbTipoDetalle.value;

            ob['features'] = lbAttributes.value;
            const chan = lbChannels.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const cit = lbCities.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const per = lbPeriods.map((obj) => { return obj.label + '|' + obj.value + '|'; });

            ob['cities'] = cit.join(',');
            ob['channels'] = chan.join(',');
            ob['periods'] = per.join(',');

            ob['is_for_export'] = 0;
            if (props.test) {
                ob['is_test'] = 1;
            } else {
                ob['is_test'] = 0;
            }

            var headers = [];

            const res = await api().post(urlFilter, ob, apiConfig());
            if (res.data.status === 'success') {
                let colum = [];
                if (res.data.response.length > 0) {
                    const head = res.data.response[0]
                    headers = Object.keys(head)

                    for (var h in headers) {
                        colum.push({
                            name: headers[h], selector: headers[h], sortable: false, wrap: true
                        })
                    }
                    setBtnExports(true);
                    setTbColumns(colum);
                    setTbData(res.data.response);
                    setTbPending(false);
                } else {
                    setBtnExports(false);
                    setTbColumns([]);
                    setTbData([]);
                    setTbPending(false);
                }
            }
        } else {
            return null;
        }
    }

    const handleToogleSideBar = () => {
        document.getElementById('options').classList.toggle('hideOptions');
        //document.getElementById('btnGenerar').classList.toggle('hideViewBtnGenerar')
    }

    const showList = () => {
        document.getElementById('list').classList.toggle('hideList');
        // document.getElementById('btnGenerar').classList.toggle('hideBtnGenerar')
    }

    useEffect(() => {
        setDefCities([]);
        setDefChannels([]);
        setDefChannels([]);
        fetchCustomers();
    }, []);
    return (
        <div>
            <div className='HeaderContent'>
                <div>
                    <TitleComponent title="Chequeos | Reporte | Amplitud de SKUS/Marcas" />
                </div>
                <div>
                    <HeaderMenu handleToogleSideBar={handleToogleSideBar} />
                </div>
            </div>
            <div id='options' className='options'>
                <CardComponent header={null} footer={null}>
                    <div className="bg-white p-2 pb-5">
                        <div className="grid md:grid-cols-3 lg:grid-cols-3 items-center gap-4 ">
                            <SelectComponent onChange={CustomerChange} options={customers} value={lbCustomer} isLoading={customerIsLoading} label="Clientes" isDisabled={Disabled} />
                            <SelectComponent onChange={CategoryChange} options={category} value={lbCategory} isLoading={categoryIsLoading} label="Categoría" />
                            <SelectComponentMulti onChange={CityChange} defaultValue={defcities} options={cities} value={lbCities} isLoading={citiesIsLoading} label="Ciudades" />
                            <SelectComponentMulti onChange={ChannelsChange} defaultValue={defchannels} value={lbChannels} options={channels} isLoading={channelsIsLoading} isDisabled={channelsIsDisabled} label="Canales" />
                            <SelectComponent onChange={AttributeChange} options={attributes} value={lbAttributes} isLoading={attributesIsLoading} label="Atributos" />
                            <SelectComponent onChange={ValoresChange} options={valores} value={lbValores} isLoading="" label="Valor" />
                            <SelectComponent onChange={TipoDetalleChange} options={tipoDetalle} value={lbTipoDetalle} isLoading="" label="Tipo de Detalle" />
                            <SelectComponent onChange={AttributeTypesChange} options={attributesType} value={lbAttributesTypes} isLoading="" label="Tipo de Reporte" />
                            <SelectComponentMulti onChange={PeriodsChange} value={lbPeriods} options={periods} defaultValue={defperiods} label={<div><label>Periodos</label><button onClick={() => {
                                setLbPeriods(periods);
                                setPeriodsIsDisabled(false);
                            }} class="ml-5 p-1 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 text-sm rounded-full">Seleccionar todos</button></div>} />
                        </div>
                    </div>
                </CardComponent>
            </div>
            <div className="p-2 justify-items-end grid">
                <div className="space-x-4">
                    <ButtonActionComponent name="GENERAR REPORTE" onClick={Filter} />
                </div>
            </div>
            <div id="list" className="list pt-3">
                <CardComponent header={<h4 className="">Distribución Numérica / Ponderada</h4>} footer={null}>
                    <div className="bg-white">
                        <div>
                        </div>
                        <TableComponent
                            keyField="work_order_id"
                            columns={tbColumns}
                            headItem={tbHeadings}
                            data={tbData}
                            pending={tbPending}
                            highlightOnHover={true}
                        />
                    </div>
                </CardComponent>
            </div>
        </div>
    )
}
export default AmplitudeAttribute;